import React, { useEffect } from "react";
import {defineBlock, smartProps, useInspectorControl, useSmartProp, EditableText, useEditor} from "../..";
import { PanelBody, PanelRow, ToggleControl, SelectControl  } from '@wordpress/components';

function Inspector(){
    const keysForms = window.keysFields;
    const currentFormId = window.currentIdForm;
    const keys = keysForms.filter(form => form.value === currentFormId)[0];
    const keysCjeckbox = keys.checkbox;

    const [required, setRequired] = useSmartProp("required");
    const [name, setName] = useSmartProp('name');

    useEffect(() => {
        if (!name) setName(keysCjeckbox[0].value);
    });

    return <PanelBody title="options" initialOpen={true}>
        <PanelRow>
            <ToggleControl
                label="Requis"
                checked={required}
                onChange={setRequired}
            />
        </PanelRow>
        <PanelRow>
            <SelectControl
                label="Clé"
                value={name}
                options={keysCjeckbox}
                onChange={setName}
            />
        </PanelRow>
    </PanelBody>
}

function SmartFormCheckbox ({label, required, name}) {
    const { isEditing } = useEditor();
    useInspectorControl(Inspector);

    return <div>
        <input id={name} name={name} required={required} type="checkbox" />
        {isEditing ? 
            <EditableText htmlFor={name} tagName="label" placeholder="Label" smartProp="label" allowedFormats={"core/link"} /> :
            <label htmlFor={name} dangerouslySetInnerHTML={{__html: label}}></label>
        }
    </div>
}

export default defineBlock({
    Block: SmartFormCheckbox,
    smartProps: {
        label: smartProps.string.withDefault('label'),
        required: smartProps.bool.withDefault(false),
        name: smartProps.string.withDefault()
    },
    setup: {
        title: "Checkbox",
    }
})